// src/utils/db.js
import Dexie from 'dexie'

class VuexDB {
    constructor() {
        this.db = new Dexie('VuexStore')
        this.db.version(1).stores({
            vuexState: 'key, value, timestamp'
        })
    }

    async saveState(state) {
        try {
            await this.db.vuexState.put({
                key: 'vuexState',
                value: state,
                timestamp: new Date().getTime()
            })
            console.log('✅ Vuex state saved to IndexedDB')
            return true
        } catch (error) {
            console.error('❌ Failed to save state to IndexedDB:', error)
            return false
        }
    }

    async loadState() {
        try {
            const record = await this.db.vuexState.get('vuexState')
            console.log('✅ Vuex state loaded from IndexedDB:', record ? 'found' : 'not found')
            return record ? record.value : null
        } catch (error) {
            console.error('❌ Failed to load state from IndexedDB:', error)
            return null
        }
    }

    async clearState() {
        try {
            await this.db.vuexState.clear()
            console.log('✅ Vuex state cleared from IndexedDB')
            return true
        } catch (error) {
            console.error('❌ Failed to clear state from IndexedDB:', error)
            return false
        }
    }
}

export default new VuexDB()